module.exports = __webpack_public_path__ + "static/media/ten-ball-header-side.28d51509.png";